import * as React from 'react';

import { useSelector } from 'react-redux';

import { ActionAfterViewed } from '@cian/action-after-viewed-component';

import { ContentSection } from '../../components/ContentSection';
import { ChartMortgageContainer } from '../Charts';
import { DynamicInfo } from '../../components/DynamicInfo';
import { getChartsData } from '../../selectors';
import { EBlockInPageName } from '../../types/share';
import { trackBlockInPageViewed } from '../../tracking';
import { NBSP } from '../../constants/symbols';
import { ACTION_AFTER_VIEWED_TIMEOUT } from '../../constants/actionAfterViewed';

export function ContentMortgageContainer() {
  const chartData = useSelector(getChartsData('mortgage'));

  const trackViewed = React.useCallback(() => {
    trackBlockInPageViewed(EBlockInPageName.MortgageRate);
  }, []);

  if (chartData && chartData.block) {
    return (
      <ActionAfterViewed callback={trackViewed} timeoutCallback={ACTION_AFTER_VIEWED_TIMEOUT}>
        <ContentSection
          title={`Средневзвешенная процентная ставка по${NBSP}ипотеке`}
          description={`Рассчитано на основе предложений банков-партнеров Циан. За${NBSP}100% принята ставка по ипотеке в${NBSP}январе${NBSP}2020`}
          mainContent={
            <DynamicInfo
              trend={chartData.block.trend}
              title={chartData.block.title}
              description={chartData.block.text}
            />
          }
          chart={<ChartMortgageContainer />}
        />
      </ActionAfterViewed>
    );
  }

  return null;
}
